import { Component, OnInit } from '@angular/core';
import { AccountServiceProvider } from '@services/user/account.service';
import { PromoCodeProvider } from '@services/subscription/promo-code.service';
import { NavBreadcrumb, User } from '@models/models';
import { Subject } from 'rxjs/Subject';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
	selector: 'profile',
	template: require('./profile.html'),
	styles: [require('./profile.scss')]
})
export class ProfileComponent implements OnInit {
	user: User;
	editedUser: User;
	breadcrumbs: Array<NavBreadcrumb> = [
		{ link: '/', title: 'Dashboard' },
		{ link: '/settings', title: 'Settings' },
		{ link: null, title: 'Account & Subscription' }
	];

	private unsubscribe: Subject<any> = new Subject();

	constructor(
		private accountService: AccountServiceProvider,
		private promoCodeService: PromoCodeProvider
	) {}

	ngOnInit(): void {
		this.getUser();
		this.checkSubscriptionInfoUpdates();
	}

	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
	}

	private getUser(): void {
		this.accountService.userDataObservable
			.pipe(
				takeUntil(this.unsubscribe),
				filter((user: User) => user !== null && typeof user !== 'undefined')
			)
			.subscribe((user: User): void => {
				this.user = JSON.parse(JSON.stringify(user));
				this.editedUser = JSON.parse(JSON.stringify(user));

				// if (user !== null && typeof user !== 'undefined') {
				//   $scope.user = JSON.parse(JSON.stringify(user));
				//   // $rootScope.hasSubscriptionBefore =
				//   //     $scope.user.hasSubscriptionBefore;
				//   $scope.editedUser = JSON.parse(JSON.stringify(user));
				//   const {
				//     annualDiscount,
				//     monthlyDiscount,
				//     subscribedAnnual,
				//     subscribedMonthly
				//   } = userService.subscriptionData;
				//   $scope.isSubscribedAnnual = subscribedAnnual;
				//   $scope.isSubscribedMonthly = subscribedMonthly;
				//   $scope.isAnnualDiscount = annualDiscount;
				//   $scope.isMonthlyDiscount = monthlyDiscount;
				//
				//   this.setFullPrise();
				// }
			});
	}

	private setFullPrise() {
		// const userData = $scope.user;
		//
		// const annualPriceType = userData.championForever
		//     ? 'annualDiscountPrice'
		//     : 'annualPrice';
		// const monthlyPriceType = userData.championForever
		//     ? 'monthlyDiscountPrice'
		//     : 'monthlyPrice';
		//
		// const annulPrice = userData.subscriptionPrice[annualPriceType];
		// const monthlyPrice = userData.subscriptionPrice[monthlyPriceType];
		//
		// $scope.fullAnnulPrice = annulPrice;
		// $scope.fullMonthlyPrice = monthlyPrice;
	}

	private checkSubscriptionInfoUpdates() {
		this.promoCodeService.updateSubscriptionPriceObservable.subscribe(() => {
			this.accountService.getUserWeb().subscribe(() => {});
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/settings/profile/profile.ts